module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-report-3.7aee992f.svg";